export default {
      id: "salary-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#salary",
      toString: function () {
        return this.url;
      }
    }